export const PersonalizationModule = {
  config(Vue, store, wsUrl) {
    let appModel =  store.getters.appModel

    if (appModel.UserModel?.Settings) {
      
      if (appModel.UserModel.Settings?.Style) {
        let sysyemStyles = appModel.Settings.Style
        let userStyles = appModel.UserModel.Settings.Style
        let doNotUseSystemStyles = appModel.UserModel.Settings?.DoNotUseSystemStyles
        appModel.UserModel.Settings.Style = setStyles(sysyemStyles, userStyles, doNotUseSystemStyles)
      }

      appModel.Settings = mergeDeep(appModel.Settings, appModel.UserModel.Settings)
    }
    let settings = appModel.Settings
    
    Vue.prototype.$Personalization = settings
    // Получение ссылки на логотип
    Vue.prototype.$Personalization.getLogoUrl = () => {
      if (!wsUrl || !Vue.prototype?.$Personalization?.Logo?.ID) {
        return
      }
      wsUrl = getCorrectWsUrl(wsUrl)
      return `${wsUrl}GetFile.ashx?file=${Vue.prototype?.$Personalization?.Logo?.ID}&nodownload=1`
    }
    appendFavicon(wsUrl, settings?.Favicon?.ID)

    setStyle(settings.Style)
  }
}
// Установка стилей приложения
function setStyle (css) {
  if (!css) {
    return
  }
  let styleElement = document.createElement('style')
  styleElement.setAttribute('type', 'text/css')

  if ('textContent' in styleElement) {
    styleElement.textContent = css
  }
  document.getElementsByTagName('head')[0].appendChild(styleElement)
}

function getCorrectWsUrl(wsUrl) {
  if (!wsUrl.endsWith('/')) {
    wsUrl += '/'
  }
  return wsUrl
}

// Обновление favicon
const appendFavicon = (wsUrl, fileName) => {
  if (!fileName || !wsUrl) {
    return
  }
  wsUrl = getCorrectWsUrl(wsUrl)
  
  let link = document.createElement('link'), oldLink = document.getElementById('app-favicon')
  link.id = 'dynamic-favicon'
  link.rel = 'shortcut icon'
  link.href = `${wsUrl}GetFile.ashx?file=${fileName}&nodownload=1`
  if (oldLink) {
    document.head.removeChild(oldLink)
  }
  document.head.appendChild(link)
}

function isObject(item) {
  return (item && typeof item === 'object' && !Array.isArray(item))
}
// Слияние двух объектов
function mergeDeep(target, ...sources) {
  if (!sources.length) { 
    return target 
  }
  const source = sources.shift()

  if (isObject(target) && isObject(source)) {
    for (const key in source) {
      if (isObject(source[key])) {
        if (!target[key]) {
          target[key] = {} 
        }
        mergeDeep(target[key], source[key])
      } else {
        if (source[key]) {
          target[key] = source[key]
        }
      }
    }
  }
  return mergeDeep(target, ...sources)
}

function setStyles (systemStyles, userStyles,  doNotUseSystemStyles) {
  if (doNotUseSystemStyles) {
    return userStyles
  }
  return systemStyles + userStyles
}